import React, { useState } from 'react'
import DashboardLayout from './DashboardLayout'
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable'
import AddEmploye from '../../../components/AddEmployee/AddEmploye'
import { Link } from 'react-router-dom'

const MyEmployees = () => {

    const [acitveEmploye, setAcitveEmploye] = useState(false)

    return (
        <>
            <DashboardLayout>
                {
                    acitveEmploye ? "" : <div className="react-table-buttons mb-4">
                        {/* <a href="#" className='btn btn-primary me-3' onClick={() => setAcitveEmploye(true)}><i className="fas fa-plus-circle"></i> Add Employee</a> */}

                        <Link to="/corporate/employee/add" className='btn btn-primary me-3'><i className="fas fa-plus-circle"></i> Add Employee</Link>

                        {/* <a href="#" className='btn btn-success me-3'>Active</a> */}

                        {/* <a href="#" className='btn btn-danger'>Deactive</a> */}
                    </div>
                }
                <ReactDataTable />
                {/* {acitveEmploye ? <AddEmploye setAcitveEmploye={setAcitveEmploye} acitveEmploye={acitveEmploye} /> : <ReactDataTable />} */}
            </DashboardLayout>
        </>
    )
}

export default MyEmployees